import { Navigate } from "react-router-dom";

export default function SuperAdminRoute({ children }) {
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  if (!token) return <Navigate to="/login" replace />;
  if (user.role !== "superadmin") return <Navigate to="/customer-flow" replace />;

  return children;
}
